import {MakeDialog} from "../../../components/Shared/MakeDialog";
import React, {Component} from "react";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import {getFormFieldValue} from "../../Applications/shared/shared";
import {postData} from "../../../api/doLogin";
import {getGlobalState} from "../../../constants/GlobalStore";
import {templateChoices} from "../constants/CalendarConstants";
import {toast} from "react-toastify";
import Chips from "react-chips";

export class MessageDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chosenCalendar: props.currentCalendar || "",
      apptType: props.apptType || "",
      eventData: props.eventData || {},
      chosenTemplate: "",
      toEmail: [],
      subject: "",
      body: "",
      loaded: false
    }
    this.loginId = getGlobalState("loginID");
  }

  getTemplateData() {
    let payload = {
      eventData: this.state.eventData,
      chosenCalendar: this.state.chosenCalendar,
    };
    // console.log(payload)
    postData(`calendar/template/${this.props.apptType}/${this.state.chosenTemplate || ""}`, payload)
      .then((data) => {
        // console.log(data)
        if (data.status === "Success") {
          this.setState({subject: data.data.subject || "", body: data.data.body, toEmail: data.data.to, loaded: true});
        } else {
          toast.error(data.message);
          console.error(data);
        }
      })
      .catch((err) => {
        toast.error("Error loading template data", err.message);
        console.error(err);
      });
  }

  send() {
    let payload = {
      to: this.state.toEmail,
      subject: this.state.subject,
      body: this.state.body,
    };
    postData(`calendar/sendemail/${this.props.eventData.id}`, payload)
      .then((data) => {
        if (data.status === "Success") {
          toast.success("Email sent successfully");
          this.props.onClose && this.props.onClose(data.data.note);
        } else {
          toast.error(data.message);
          console.error(data);
        }
      })
      .catch((err) => {
        toast.error(`Error sending email: ${err.message}`);
        console.error(err);
      });
  }

  render() {

    const disabled = this.state.toEmail.length === 0 || this.state.subject.length === 0 || this.state.body.length === 0;
    return (
      <MakeDialog isOpen={true}
                  className={"TransferCalendarDialog"}
                  footer={<div>
                    <Button color={"primary"}
                            disabled={disabled}
                            onClick={() => this.send()}>Send</Button>
                    <Button onClick={() => this.props.onClose && this.props.onClose()}>Close</Button>
                  </div>}
                  header="Generate Email">
        <Row>
          <Col xs={12} md={3}>
            <FormGroup>
              <Label for="chosenTemplate">Select Template</Label>
              <Input type="select" id="chosenTemplate" placeholder=""
                     value={getFormFieldValue(this.state.chosenTemplate)}
                     onChange={(evt) => this.setState({chosenTemplate: evt.target.value}, () => {
                       this.getTemplateData();
                     })}>
                >
                <option key={0} value={""} disabled={true}>Select Template...</option>
                {templateChoices.map((val, i) => {
                  return <option key={i + 1} value={val}>{val}</option>
                })}
              </Input>
            </FormGroup>
          </Col>
          <Col xs={12} md={9}>
            <FormGroup>
              <Label for="sendTo">To</Label>
              <Chips id={"sendTo"}
                     value={this.state.toEmail}
                     onChange={(chips) => this.setState({toEmail: chips})}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <FormGroup>
              <Label for="subject">Subject</Label>
              <Input type="text" id="subject" placeholder=""
                     value={this.state.subject}
                     onChange={(evt) => this.setState({subject: evt.target.value})}/>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <FormGroup>
              <Label for="body">Message</Label>
              <Input type="textarea" id="body" placeholder=""
                     rows={10}
                     value={this.state.body}
                     onChange={(evt) => this.setState({body: evt.target.value})}/>
            </FormGroup>
          </Col>
        </Row>

      </MakeDialog>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Calendar/modals/MessageDialog.js